import { useTranslation } from 'react-i18next'
import { LangText } from '@/components'
import { useNavigate } from 'react-router-dom'
import { preFixImgUrl } from '@/utils'

const CarRental = () => {
  const { t } = useTranslation();
  const navigate = useNavigate();

  const services = [
    {
      img: preFixImgUrl('4dd456a7c6dcee0cc93bf48321417006.png'),
      icon: preFixImgUrl('328d9478da6822d54a107efc69497547.png'),
      title: '机场接送',
      titleKey: '28a05656',
      content: '专车接送往返机场与酒店，省去等待和换乘的麻烦，舒适安全到达目的地',
      contentKey: 'f859a2c7',
      subItems: [
        {
          text: '准点接机服务',
          textKey: 'b8053439', 
          key: 'f8c4e3a1'
        },
        {
          text: '中文司机沟通无忧',
          textKey: 'bf024c28',
        },
        {
          text: '大件行李无限制',
          textKey: '604d0419',
        },
        {
          text: '儿童座椅免费提供',
          textKey: '02b356d0', 
        }
      ]
    },
    {
      img: preFixImgUrl('abff555fac042664babb3fae1ed9dc99.png'),
      icon: preFixImgUrl('557ce6207f478ad1518b73ad4eed663d.png'),
      title: '包车游览',
      titleKey: '97a4def0',
      content: '专车专人全天服务，自由安排行程路线，深度游览富士山、箱根、京都等热门景点',
      contentKey: 'c0552906',
      subItems: [
        {
          text: '灵活定制路线',
          textKey: '92efa471',
        },
        {
          text: '中文导游讲解',
          textKey: 'fb54df20', 
        },
        {
          text: '景点门票代购',
          textKey: '515a87e8', 
        },
        {
          text: '餐厅推荐预约',
          textKey: '92f72149', 
        }
      ]
    },
    {
      img: preFixImgUrl('e7578260fe8b8c128931d9cb3abecab4.png'),
      icon: preFixImgUrl('0c50edd8e898772cf7c7d79f47cbc0b6.png'),
      title: '多日租车',
      titleKey: 'bdcaeaa3',
      content: '自驾游日本，配备中文导航系统，提供详细驾驶指南，让您自由探索日本各地',
      contentKey: 'fcc19b7d',
      subItems: [
        {
          text: '中文导航系统',
          textKey: '6e27e1d6', 
        },
        {
          text: '驾驶指南手册',
          textKey: '56b4be65', 
        },
        {
          text: '24小时道路救援',
          textKey: '1fa3d7c7', 
        },
        {
          text: '免费增驾人员',
          textKey: '781c3640', 
        }
      ]
    }
  ]

  const cars = [
    {
      img: preFixImgUrl('5f2b5c31f1e5e3345cb57f3c01f4fc22.png'),
      title: '经济型轿车',
      titleKey: '72269ca7',
      seats: 4,
      luggage: 2,
      price: 500,
    },
    {
      img: preFixImgUrl('adf4a4c10ec1f86c3661cc22d19f14fd.png'),
      title: '商务轿车',
      titleKey: '003fb8c8',
      seats: 4,
      luggage: 3,
      price: 800,
    },
    {
      img: preFixImgUrl('773e3919618a540c828c142b197cd5ca.png'),
      title: '7座MPV',
      titleKey: '79ea3c40',
      seats: 7,
      luggage: 5,
      price: 1200,
    },
    {
      img: preFixImgUrl('b7d38dc58cdd5a59a20339b825736614.png'),
      title: '豪华SUV',
      titleKey: 'd5450022',
      seats: 5,
      luggage: 4,
      price: 1500,
    },
  ]

  return (
    <div>
      <div className='w-full bg-cover bg-center bg-no-repeat' style={{ backgroundImage: `url(${preFixImgUrl('60e102fac375afe4c5da3095c0a9d6ec.png')})` }}>
        <div className='max-w-8xl mx-auto px-10 h-[800px] flex items-center'>
          <div className='bg-[#F2FDEF] rounded-[20px] w-full flex items-center justify-between p-15'>
            <div className='flex flex-col justify-center'>
              <div className='rounded-[12px] rounded-bl-[0] bg-[#3DAE26] w-fit h-[35px] leading-[35px]'>
                <LangText lngKey='a20489a2' className='text-white text-[18px] px-3'>{t('a20489a2')}</LangText>
              </div>
              <LangText lngKey='5d8c4d87' className='text-[44px] text-black mt-6'>{t('5d8c4d87')}</LangText>
              <LangText lngKey='7e33a896' className='text-[18px] text-[#666666] w-[540px] leading-[1.5] mt-5'>{t('7e33a896')}</LangText>
              <div className='flex gap-4 mt-6'>
                <div className='h-[47px] px-[35px] flex items-center justify-center rounded-[24px]  w-fit text-[18px] bg-linear-to-r from-[#34A81D] to-[#62C647] text-white cursor-pointer' onClick={() => navigate('/car-rental/reserve')} >
                  <LangText lngKey='bcc799b1'>{t('bcc799b1')}</LangText>
                </div>
                {/* <div className='h-[47px] px-[35px] flex items-center justify-center rounded-[24px] outline outline-[#131313] w-fit text-[18px] hover:bg-linear-to-r from-[#34A81D] to-[#62C647] hover:text-white hover:outline-none cursor-pointer'>
                  <LangText lngKey='eb13743b'>{t('eb13743b')}</LangText>
                </div> */}
              </div>
            </div>
            <img src={preFixImgUrl('f41c5eff61cb51f727003b212c4e82ca.png')} className='h-[361px] w-[486px]' />
          </div>
        </div>
      </div>
      {/* 多样化用车服务 */}
      <div className='bg-[#E8F7E9] pt-[170px] pb-[200px]'>
        <div className='max-w-8xl mx-auto px-10 text-center flex flex-col items-center'>
          <LangText className='text-[36px] font-bold text-black' lngKey='a1c222f7'>{t('a1c222f7')}</LangText>
          <LangText className='text-[24px] text-[#666666] mt-[28px]' lngKey='5e1fd28b'>{t('5e1fd28b')}</LangText>
          <div className='flex justify-between items-stretch mt-[104px] gap-[30px] '>
            {
              services.map(service => {
                return (
                  <div key={service.title} className='rounded-[20px] bg-white px-4 pt-5 pb-9 flex flex-col items-start'>
                    <img src={service.img} alt={service.title} className='h-[243px] w-full' />
                    <div className='flex items-center gap-[25px] mt-6'>
                      <img src={service.icon} alt={service.title} className='h-[24px]' />
                      <LangText lngKey={service.titleKey} className='text-[30px] font-bold text-black'>{t(service.titleKey)}</LangText>
                    </div>
                    <LangText lngKey={service.contentKey} className='text-[18px] text-[#666666] mt-5 text-left leading-[1.5]'>{t(service.contentKey)}</LangText>
                    <div className='mt-9 flex flex-col gap-5'>
                      {
                        service.subItems.map(subItem => {
                          const itemText = typeof subItem === 'string' ? subItem : subItem.text;
                          const itemKey = typeof subItem === 'string' ? subItem : subItem.textKey;
                          return (
                            <div key={itemText} className='flex items-center gap-[10px]'>
                              <img src={preFixImgUrl('1d655cd9149ff1a8dc05dd12cb506d6a.png')} alt={itemText} className='h-[20px]' />
                              <LangText lngKey={itemKey} className='text-[18px] text-left leading-[1.2]'>{t(itemKey)}</LangText>
                            </div>
                          )
                        })
                      }
                    </div>

                  </div>
                )
              })
            }
          </div>
        </div>
      </div>
      {/* 丰富车型选择 */}
      <div className='bg-[#FAFAFA] py-[128px]'>
        <div className='max-w-8xl mx-auto px-10 text-center flex flex-col items-center'>
          <LangText className='text-[36px] font-bold text-black' lngKey='32823dba'>{t('32823dba')}</LangText>
          <LangText className='text-[24px] text-[#666666] mt-[30px]' lngKey='dd91a2e0'>{t('dd91a2e0')}</LangText>
          <div className='flex justify-between items-stretch mt-[88px] gap-5 '>
            {
              cars.map(car => {
                return (
                  <div key={car.title} className='rounded-[20px] bg-white'>
                    <img src={car.img} alt={car.title} className='h-[243px]' />
                    <div className='px-6 flex flex-col items-start pt-5 pb-8'>
                      <LangText className='text-[30px] font-bold' lngKey={car.titleKey}>{t(car.titleKey)}</LangText>
                      <div className='flex items-center gap-[14px] mt-[24px]'>
                        <img src={preFixImgUrl('2ab8adff845de128c8e6ee501501b74d.png')} alt={car.title} />
                        <LangText className='text-[24px] text-[#666666] text-left lang-en:text-[20px]' lngKey='28cda8ff'>{t('28cda8ff',{ seats: car.seats })}</LangText>
                      </div>
                      <div className='flex items-center gap-[14px] mt-[15px]'>
                        <img src={preFixImgUrl('928bef297a4025cec8bf4da279ac1436.png')} alt={car.title} />
                        <LangText className='text-[24px] text-[#666666] text-left leading-[1.5] lang-en:text-[20px]' lngKey='2be9edca'>{t('2be9edca',{ luggage: car.luggage })}</LangText>
                      </div>
                      <LangText className='text-[26px] text-[#4FA53D] mt-[27px] font-bold text-left' lngKey='dea98fc5'>{t('dea98fc5', { price: car.price })}</LangText>
                    </div>
                  </div>
                )
              })
            }
          </div>
        </div>
      </div>
      {/* 服务保障 */}
      <div className='bg-[#EFF8EC] pt-[110px] pb-[180px]'>
        <div className='max-w-8xl mx-auto px-10 text-center flex flex-col items-center'>
          <LangText className='text-[36px] font-bold text-black' lngKey='0117a822'>{t('0117a822')}</LangText>
          <div className='flex justify-between mt-[93px] gap-[21px] items-stretch leading-[1.5]'>
            <div className='w-[285px] px-[40px] pt-[37px] pb-[30px] bg-linear-to-t from-[#34A81D] to-[#62C647] rounded-[20px] flex flex-col justify-start items-center'>
              <div className='w-[89px] h-[89px] rounded-[50%] bg-white flex justify-center items-center'>
                <img src={preFixImgUrl('08742c843dc330cb322c77844b5eb82a.png')} className='h-[44px]' />
              </div>
              <LangText lngKey='ec484367' className='text-[30px] text-white mt-[26px]'>{t('ec484367')}</LangText>
              <LangText lngKey='0d0f3a1c' className='text-[22px] text-white mt-[16px] leading-[1.5] font-normal'>{t('0d0f3a1c')}</LangText>
            </div>
            <div className='w-[285px] px-[44px] pt-[37px] pb-[30px] bg-linear-to-t from-[#34A81D] to-[#62C647] rounded-[20px] flex flex-col justify-start items-center'>
              <div className='w-[89px] h-[89px] rounded-[50%] bg-white flex justify-center items-center'>
                <img src={preFixImgUrl('4ab49fcf9b3c772c21d86c9491aa8ae6.png')} className='h-[44px]' />
              </div>
              <LangText lngKey='ef9c91cb' className='text-[30px] text-white mt-[26px]'>{t('ef9c91cb')}</LangText>
              <LangText lngKey='965f71ac' className='text-[22px] text-white mt-[16px] leading-[1.5] font-normal'>{t('965f71ac')}</LangText>
            </div>
            <div className='w-[285px] px-[44px] pt-[37px] pb-[30px] bg-linear-to-t from-[#34A81D] to-[#62C647] rounded-[20px] flex flex-col justify-start items-center'>
              <div className='w-[89px] h-[89px] rounded-[50%] bg-white flex justify-center items-center'>
                <img src={preFixImgUrl('7b1b4c7453f96e562052312d2b27efad.png')} className='h-[44px] -ml-[6px]' />
              </div>
              <LangText lngKey='4048b3c3' className='text-[30px] text-white mt-[26px]'>{t('4048b3c3')}</LangText>
              <LangText lngKey='8e435bc3' className='text-[22px] text-white mt-[16px] leading-[1.5] font-normal'>{t('8e435bc3')}</LangText>
            </div>
            <div className='w-[285px] px-[40px] pt-[37px] pb-[30px] bg-linear-to-t from-[#34A81D] to-[#62C647] rounded-[20px] flex flex-col justify-start items-center'>
              <div className='w-[89px] h-[89px] rounded-[50%] bg-white flex justify-center items-center'>
                <img src={preFixImgUrl('02dbfafdc8ec6c5e2519c78d1345f34b.png')} className='h-[44px]' />
              </div>
              <LangText lngKey='1797198c' className='text-[30px] text-white mt-[26px]'>{t('1797198c')}</LangText>
              <LangText lngKey='a7ad02d9' className='text-[22px] text-white mt-[16px] leading-[1.5] font-normal'>{t('a7ad02d9')}</LangText>
            </div>
          </div>
        </div>
      </div>
      <div className='w-full h-[436px] bg-cover bg-center bg-no-repeat flex flex-col items-center' style={{ backgroundImage: `url(${preFixImgUrl('75a91e24b26ea51cb82d2b53925f46c6.png')})` }}>
        <LangText className='text-white text-[44px] mt-[113px]' lngKey='4b5882b6'>{t('4b5882b6')}</LangText>
        <LangText className='text-white text-[30px] mt-[30px] font-normal' lngKey='be5458af'>{t('be5458af')}</LangText>
        <div className='flex gap-[25px] mt-[60px]'>
          <div
            onClick={() => navigate('/car-rental/reserve')}
            className='h-[62px] text-white min-w-[231px] px-[44px] flex items-center justify-center rounded-[31px] w-fit text-[24px] bg-linear-to-r from-[#34A81D] to-[#62C647] outline-none cursor-pointer '
          >
            <LangText lngKey='bcc799b1'>{t('bcc799b1')}</LangText>
          </div>
          <div
            className='h-[62px] text-white min-w-[231px] px-[44px] flex items-center justify-center rounded-[31px] outline outline-white w-fit text-[24px]  cursor-pointer '
            onClick={() => navigate('/service-center')}
          >
            <LangText lngKey='c6064fc3'>{t('c6064fc3')}</LangText>
          </div>
        </div>
      </div>
    </div>
  )
}

export default CarRental